const loadingFeatures = [
    {
        type: 'release',
        name: 'loading1',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
    {
        type: 'release',
        name: 'loadg2',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
    {
        type: 'release',
        name: 'loading3',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
    {
        type: 'release',
        name: 'loadi4',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
    {
        type: 'release',
        name: 'loadi5',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
    {
        type: 'release',
        name: 'loadg6',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
    {
        type: 'release',
        name: 'loading7',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
    {
        type: 'release',
        name: 'ln8',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
    {
        type: 'release',
        name: 'load9',
        environments: [
            {
                name: ':global:',
                displayName: 'Across all environments',
                enabled: true,
            },
        ],
    },
];

export default loadingFeatures;
